import React, { useState, useCallback, useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import { ReportSectionHeader } from "../../common/components/SectionHeader";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import { getFunctionList, getUSstates, validate } from "../../util";
import "./register.css";
import Axios from "axios";
import { apiUri } from "../../config";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";

const Label = ({ children }) => (
  <label className="sar-input-label">{children}</label>
);

const Field = React.memo(({ inValid = {}, label, children }) => {
  return (
    <React.Fragment>
      <Grid item xs={4}>
        <Label>{label}</Label>
      </Grid>
      <Grid item xs={8}>
        {children}
        {inValid.message && (
          <div className="error-msg-block">
            <div className="error-msg">{inValid.message}</div>
          </div>
        )}
      </Grid>
    </React.Fragment>
  );
});

const Input = React.memo((props) => {
  const { inValid = {}, placeholder, type = "text", label, ...rest } = props;
  return (
    <Field {...props}>
      <input
        type={type}
        {...rest}
        className={`sar-input fullwidth ${inValid.message ? "error" : ""}`}
        placeholder={placeholder || `Enter ${label}`}
      />
    </Field>
  );
});

const Select = React.memo((props) => {
  const { label, inValid = {}, value, list, ...rest } = props;
  return (
    <Field {...props}>
      <select
        value={value}
        {...rest}
        placeholder={`Select ${label}`}
        className={`sar-input fullwidth ${!value ? "invalid" : ""} ${
          inValid.message ? "error" : ""
        }`}
      >
        <option>{`Select ${label}`}</option>
        {list.map(({ value, name }, index) => (
          <option key={index} value={value}>
            {name}
          </option>
        ))}
      </select>
    </Field>
  );
});

const RegisterForm = ({ handleNext, setRegUserInfo }) => {
  const [user, setUser] = useState({
    email: "",
    // password: "",
    // confirmPassword: "",
    firstName: "",
    lastName: "",
    company: "",
    industry: "",
    functionValue: "",
    title: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: undefined,
  });

  const [inValid, setInValid] = useState({});

  const functionList = getFunctionList().map((value) => ({
    name: value,
    value,
  }));

  const stateList = getUSstates();

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      name !== "zip" ||
      (name === "zip" && (!value || (value && value.length < 6)))
    ) {
      setUser((prevUser) => ({ ...prevUser, [name]: value }));
      if (Object.keys(inValid).length > 0) {
        setInValid((prevInValid) => {
          const updatedInValid = { ...prevInValid };
          if (!value) {
            updatedInValid[name] = { message: "Required" };
          } else {
            delete updatedInValid[name];
          }
          return updatedInValid;
        });
      }
    }
  };

  const validateForm = () => {
    const error = {};

    for (const key in user) {
      if (!user[key]) {
        error[key] = { message: "Required" };
      }
    }

    if (user.email && !validate.email(user.email)) {
      error.email = { message: "Enter valid email" };
    }

    if (user.phone && !validate.phone(user.phone)) {
      error.phone = { message: "Enter valid phone number" };
    }

    if (user.zip && !validate.zip(user.zip)) {
      error.zip = { message: "Enter valid zip code" };
    }

    // if (
    //   user.password &&
    //   user.confirmPassword &&
    //   user.password !== user.confirmPassword
    // ) {
    //   error.confirmPassword = { message: "Password does not match." };
    // }

    setInValid(error);
    return Object.keys(error).length === 0;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const payload = { ...user, function: user.functionValue };
      delete payload.functionValue;
      delete payload.confirmPassword;
      Axios.post(apiUri + "/register/createUser", payload)
        .then((response) => {
          if (
            response.data &&
            response.data.statusCode === 200 &&
            response.data.statusMessage !== "User Created Successfully!" &&
            response.data.statusMessage !== "OK"
          ) {
            const error = {};
            error.email = { message: "User already exists with this email" };
            setInValid(error);

            NotificationManager.error(
              `User already exists with email ${user.email}`,
              "Failure",
              3000
            );
          } else if (
            response.status === 200 &&
            response.data &&
            response.data.content
          ) {
            setRegUserInfo({ ...response.data.content });
            handleNext();
          } else if (
            (response.status === 409 ||
              response.status === 400 ||
              response.data.statusCode === 409 ||
              response.data.statusCode === 400) &&
            response.data.statusMessage
          ) {
            NotificationManager.error(response.data.statusMessage, "Failure");
          }
        })
        .catch((err) => {
          console.log(err);
          NotificationManager.error(err.message, "Failure");
        });
    }
  };

  const {
    email,
    // password,
    // confirmPassword,
    firstName,
    lastName,
    company,
    industry,
    functionValue,
    title,
    phone,
    address,
    city,
    state,
    zip,
  } = user;

  return (
    <Grid container style={{ justifyContent: "center" }}>
      <Grid item xs={12} sm={8} md={6}>
        <div style={{ margin: "0 8%" }}>
          <ReportSectionHeader>
            <h4>ACE Alerts Registration</h4>
          </ReportSectionHeader>
          <br />
          <HeaderDivider />
          <br />
          <form
            noValidate
            onSubmit={handleFormSubmit}
            className="registraion-form"
          >
            <Grid container spacing={3}>
              <Input
                label="Email"
                type="email"
                name="email"
                value={email}
                onChange={handleChange}
                inValid={inValid.email}
              />
              {/* <Input
                label="Password"
                type="password"
                name="password"
                value={password}
                onChange={handleChange}
                inValid={inValid.password}
              />
              <Input
                label="Confirm Password"
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={handleChange}
                inValid={inValid.confirmPassword}
                placeholder="Confirm Password"
              /> */}
              <Input
                label="First Name"
                name="firstName"
                value={firstName}
                onChange={handleChange}
                inValid={inValid.firstName}
              />
              <Input
                label="Last Name"
                name="lastName"
                value={lastName}
                onChange={handleChange}
                inValid={inValid.lastName}
              />
              <Input
                label="Company"
                name="company"
                value={company}
                onChange={handleChange}
                inValid={inValid.company}
              />
              <Input
                label="Industry"
                name="industry"
                value={industry}
                onChange={handleChange}
                inValid={inValid.industry}
              />
              <Select
                label="Function"
                name="functionValue"
                value={functionValue}
                onChange={handleChange}
                list={functionList}
                inValid={inValid.functionValue}
              />
              <Input
                label="Job Title"
                name="title"
                value={title}
                onChange={handleChange}
                inValid={inValid.title}
              />
              <Input
                label="Phone"
                name="phone"
                value={phone}
                onChange={handleChange}
                inValid={inValid.phone}
              />
              <Input
                label="Address"
                name="address"
                value={address}
                onChange={handleChange}
                inValid={inValid.address}
              />
              <Input
                label="City"
                name="city"
                value={city}
                onChange={handleChange}
                inValid={inValid.city}
              />
              <Select
                label="State"
                name="state"
                value={state}
                onChange={handleChange}
                list={stateList}
                inValid={inValid.state}
              />
              <Input
                type="number"
                label="Zip"
                name="zip"
                value={zip}
                onChange={handleChange}
                inValid={inValid.zip}
              />
            </Grid>
            <br />
            <div className="right">
              <button className="sar-btn">Submit</button>
            </div>
          </form>
        </div>
        <NotificationContainer />
      </Grid>
    </Grid>
  );
};

export default RegisterForm;



// WEBPACK FOOTER //
// ./src/components/Register/user.jsx